// Base value injected into theme
export const THEME_BASE_BORDER_RADIUS = 4
export const BORDER_RADIUS = 2 // TODO - phase out

// Multiplier for `theme.shape.borderRadius` to be used for setting all
// application radius
export const BUTTON_RADIUS_MULTIPLIER = 5
export const SEARCH_BAR_ITEM_RADIUS_MULTIPLIER = 12
export const ITEM_BORDER_MULTIPLIER = 2
export const CARD_RADIUS_MULTIPLIER = 12

export const WIDE_PADDING = 4
export const PADDING_BASE_MULTIPLIER = 2

export const INPUT_HELP_TOOLTIP_SPACING = 4

export const GRID_SPACING = 2
